var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monitor-contanier"},[_c('div',{staticClass:"monitor-control-contanier"},[_c('Control',{attrs:{"meeting":_vm.meeting}})],1),_c('List',{attrs:{"meeting":_vm.meeting}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }